// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8caace11","977":"a7ea688e"}[chunkId] + ".chunk.js";
};